export default {
  brand: {
    name: "比翼鸟",
  },
  lang: {
    zh: "中文",
    en: "EN",
  },
  header: {
    checkUpdate: "检查更新",
    forceReload: "强制刷新缓存",
    personal: "个人中心",
    logout: "退出登录",
  },
  tags: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeLeft: "关闭左侧",
    closeAll: "关闭所有",
  },
  common: {
    sendSuccess: "发送成功",
  },
  login: {
    passwordLogin: "密码登录",
    smsLogin: "验证码登录",
    adminLogin: "管理员登录",
    wechatLogin: "微信扫码登录",
    bindPhone: "绑定手机号",
    username: "请输入用户名",
    password: "请输入密码",
    phone: "请输入手机号",
    sms: "请输入验证码",
    sendCode: "发送验证码",
    seconds: "秒",
    loginNow: "立即登录",
    bind: "绑定",
    register: "立即注册",
    adminEntry: "管理员登录",
    backUser: "返回用户登录",
    wechatTip: "打开微信扫一扫，快速登录",
    backAccount: "返回账号登录",
    thirdPartyLogin: "其他方式登录",
    promoSub: "云中控 · 低代码智控新范式",
    promo1: "免编程：低代码平台、组件化设计",
    promo2: "模块化：分布式结构、POE 供电、IP 控制",
    promo3: "云架构：云端设计、云端管理、云端存储",
    clientDownload: "客户端下载",
    tryNow: "立即体验",
  },
  register: {
    title: "注册账号",
    phone: "请输入手机号",
    sms: "请输入验证码",
    password: "请设置密码（不少于6位）",
    confirm: "请再次输入密码",
    submit: "注册并登录",
    hasAccount: "已有账号，去登录",
    sendCode: "发送验证码",
    seconds: "秒",
    mismatch: "两次密码不一致",
    setPassword: "请设置密码",
    min6: "不少于6位",
  },
  menus: {
    "/homePage": "我的首页",
    "/uiDesign": "UI设计",
    "/privateResource": "私有资源库",
    "/privateResource/materials": "素材管理",
    "/privateResource/directiveTypes": "指令类型",
    "/privateResource/manage": "私有指令",
    "/publicResource": "公共资源库",
    "/publicResource/publicDirective": "公共指令",
    "/publicResource/publicMaterial": "公共素材",
    "/projects": "工程管理",
    "/helps": "帮助",
    "/userManage": "用户管理",
    "/userManage/users": "注册用户",
    "/userManage/managers": "管理员",
    "/userManage/transferLogs": "工程交接记录",
    "/userManage/canvasAiModels": "画布AI模型",
    "/secretKeys": "密钥管理",
    "/secretKeys/online": "线上密钥",
    "/secretKeys/local": "本地密钥",
    "/secretKeys/hub": "WirdHouse 授权",
    "/roles": "角色管理",
    "/roles/list": "角色列表",
    "/roles/bindMenus": "菜单绑定",
    "/menus": "菜单管理",
    "/helpDocuments": "帮助文档管理",
    "/templates": "审批工单",
    "/clientManage": "客户端管理",
    "/clientManage/apk": "APK管理",
    "/clientManage/qt": "QT管理",
    "/clientManage/mac": "Mac管理",
    "/clientManage/ios": "iOS管理",
    "/personal": "个人中心",
    "/homePage/moreTemplates": "更多模板",
    "/projects/projectsEdit": "工程编辑",
    "/projects/create": "新建工程",
    "/privateResource/directiveTypes/edit": "编辑",
    "/privateResource/directiveTypes/add": "新增",
    "/privateResource/manage/edit": "编辑",
    "/privateResource/manage/add": "新增",
    "/publicResource/publicDirective/add": "公共指令新增",
    "/publicResource/publicDirective/edit": "公共指令编辑",
    "/publicResource/publicDirective/view": "公共指令查看",
    "/clientManage/apk/add": "apk新增",
    "/clientManage/apk/edit": "apk修改",
    "/clientManage/qt/add": "qt新增",
    "/clientManage/qt/edit": "qt修改",
    "/clientManage/mac/add": "Mac新增",
    "/clientManage/mac/edit": "Mac修改",
    "/clientManage/ios/add": "iOS新增",
    "/clientManage/ios/edit": "iOS修改",
    "/client/releases": "客户端版本记录",
    "/projects/add": "新建工程",
    "/helps/edit": "详情",
    "/userManage/users/edit": "编辑",
    "/userManage/managers/edit": "编辑",
    "/userManage/managers/add": "新增",
    "/menus/edit": "编辑",
    "/menus/add": "新增",
    "/helpDocuments/edit": "编辑",
    "/helpDocuments/add": "新增",
  },
  clientFieldHelp: {
    upload_apk: "上传 Android 安装包（.apk）。保存后生成下载地址，供 OTA 与版本库使用。",
    upload_qt: "上传 Windows / 麒麟客户端安装包。Windows 为 .exe；麒麟按所选架构上传对应包。",
    upload_mac: "上传 macOS 安装包（.dmg / .pkg / .zip），须与所选 CPU 架构一致。",
    upload_ios: "上传 iOS 安装包（.ipa）。",
    channel: "区分 Windows 与麒麟 V10。Mac / iOS 管理页会自动固定平台，无需再选。",
    cpu_arch: "须与安装包实际架构一致。Windows 为通用包无需选择；麒麟选 x86 或 ARM；Mac 选 Apple Silicon 或 Intel。",
    name: "对外展示的版本号（如 1.2.0），客户端 OTA 与版本库均按此识别。",
    white_list_status: "开启后，仅白名单内设备可通过 OTA 接口检测到本版本；关闭则对所有设备按 OTA 规则检测。",
    white_list: "设备唯一标识，每行一个。仅当「白名单状态」为是时生效，用于灰度或内测。",
    version_log: "写给用户的更新说明，会显示在登录页下载区、下载弹窗和「客户端版本记录」页。",
    status: "是否参与客户端在线升级（/upgrade 检测）。选「是」：已安装客户端可收到此版本；选「否」：仅存档，OTA 不推送。",
    catalog_show: "是否在公开「版本库」展示（登录页下载、历史版本列表）。与 OTA 独立：可只推升级不在网页列出，或只在网页提供下载。",
    remark: "补充说明（场景、注意事项等），与更新日志一起展示给用户。",
  },
};
